import { gql } from '@mineko/graphql-client';

export default gql`
  query ($slug: String!) {
    IntegratedPartnerBySlug(slug: $slug) {
      id
      slug
      partnerType
      options
    }
  }
`;
